// Angular
import { Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
// Environment
import { environment } from '@env/environment';
// Models
import { IConfig } from '@core/config/config.interface';
// Services
import { CurrencyService } from '../../../../shared/services/currency.service';
import { ConfigService } from '@core/config/config.service';
import { SessionService } from '@core/services-v2/session/session.service';
import { SellerTopbar } from './seller-topbar.interface';

@Component({
  selector: 'app-header-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  @Input() desde: string = '';
  config: IConfig;
  showCartHeader!: boolean;
  isB2B: boolean;
  isStatic: boolean = environment.promoHeader.isStatic;
  staticText: string | null = environment.promoHeader.staticText;
  b2bText: string | null = environment.promoHeader.b2bText;
  b2cText: string | null = environment.promoHeader.b2cText;

  country = environment.country;

  seller: SellerTopbar | null = null;
  sellerLabel: string | null = null;

  currentUrl: string = '';

  constructor(
    public readonly currencyService: CurrencyService,
    private readonly router: Router,
    private readonly configService: ConfigService,
    private readonly sessionService: SessionService,
    private readonly route: ActivatedRoute
  ) {
    this.config = this.configService.getConfig();
    this.isB2B = this.sessionService.isB2B();
    // Obtener la ruta inicial
    this.currentUrl = this.router.url;
    this.getQueryParams();
  }

  ngOnInit(): void {
    this.hideMenub2c();
    //this.onUrlChange();
  }

  /*onUrlChange(): void {
    // Detectar la ruta inicial y cambios de ruta
    this.currentUrl = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects || event.url;
        console.log('Ruta actual:', this.currentUrl);
      }
    });
  }*/

  private getQueryParams(): void {
    this.route.queryParams.subscribe((params) => {
      if (params['nombre'] || params['correo'] || params['telefono']) {
        this.seller = {
          name: params['nombre'] || '-',
          email: params['correo'] || '-',
          phone: params['telefono'] || '-',
        };
      }
    });
  }

  private hideMenub2c(): void {
    // Usar currentUrl en lugar de router.url directamente
    if (
      this.currentUrl.includes('/carro-compra/') &&
      this.currentUrl !== '/carro-compra/comprobante-de-solicitud'
    ) {
      this.showCartHeader = true;
    } else {
      this.showCartHeader = false;
    }
  }
}
